import { useTranslation } from 'react-i18next'

export function PublicFooter() {
  const { t } = useTranslation()
  const year = new Date().getFullYear()

  return (
    <footer className="w-full py-6 flex flex-col items-center gap-2">
      <div className="flex items-center gap-3 text-xs text-muted-foreground/60">
        <a
          href="/legal/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-muted-foreground transition-colors"
        >
          {t('legal.nav.terms', 'Terms')}
        </a>
        <span>·</span>
        <a
          href="/legal/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-muted-foreground transition-colors"
        >
          {t('legal.nav.privacy', 'Privacy')}
        </a>
        <span>·</span>
        <a
          href="/legal/cookies"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-muted-foreground transition-colors"
        >
          {t('legal.nav.cookies', 'Cookies')}
        </a>
      </div>
      <p className="text-xs text-muted-foreground/40">
        © {year} HD Parrainage. {t('legal.allRightsReserved', 'All rights reserved.')}
      </p>
    </footer>
  )
}
